import { action } from 'mobx';

import { getErrorString, Logger, NOOP_LOGGER } from 'bernie-logger';
import { ContextStore, SerializedData, Store, timeoutPromise } from 'bernie-core';
import { CustomerInterest } from 'models/common/customer-interest';
import { BexApiSource } from 'sources/bex-api-source';
import { getCustomerIntentInput, mapCustomerInterests } from './adapters/bex-api/search/customer-interest-adapter';
import { Customer, OperationResult } from '__generated__/api';
import { STORE_EVENTS } from 'stores/events/store-events';

export class CustomerInterestsStore extends Store {
  public customerInterests: CustomerInterest[] = [];
  private readonly timeOut: number;

  constructor(private bexApiSource: BexApiSource, state: SerializedData = {}, logger: Logger = NOOP_LOGGER, timeOut: number) {
    super(state, logger);
    this.timeOut = timeOut;
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  @action
  public async fetch(context: ContextStore, semdtl: string): Promise<CustomerInterest[]> {
    const variables: Customer.Variables = getCustomerIntentInput(context, semdtl);
    //call customer spinner even if semdtl is null as customer spinner provides customer interests of user for last 30 days
    const promise = timeoutPromise(this.fetchCustomerInterest(variables), this.timeOut, 'Timed out while fetching customer Interests');
    await promise
      .then(({ data }) => {
        this.customerInterests = mapCustomerInterests(data);
      })
      .catch(error => {
        const fetchErrorEvent = semdtl
          ? STORE_EVENTS.BEX_API_CUSTOMER_STORE_FETCH_ERROR_WITH_SEMDTL
          : STORE_EVENTS.BEX_API_CUSTOMER_STORE_FETCH_ERROR_NO_SEMDTL;
        this.logger.logEvent(fetchErrorEvent, getErrorString(error));
      });

    return new Promise<CustomerInterest[]>(resolve => {
      resolve(this.customerInterests);
    });
  }

  private fetchCustomerInterest(variables: Customer.Variables): Promise<OperationResult<Customer.Query>> {
    return this.bexApiSource.fetchCustomerIntent(variables);
  }
}
